module.exports = __webpack_public_path__ + "images/Cinema-4bb9428ef28bcb29f86f8ce009497fc5.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/Logos_icons/Cinema.svg
// module id = 767
// module chunks = 0